import { Cv } from "src/app/models/cv";
import { Router } from "@angular/router";
import { MatSort } from "@angular/material/sort";
import { CvService } from "src/app/services/cv.service";
import { MatPaginator } from "@angular/material/paginator";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { AuthenticationService } from "src/app/services/authentication.service";

@Component({
    selector: "app-company-dashboard",
    templateUrl: "./company-dashboard.component.html",
    styleUrls: ["./company-dashboard.component.scss"]
})
export class CompanyDashboardComponent implements OnInit {

    displayedColumns: string[] = ['firstName', 'lastName', 'faculty', 'city', 'generate'];
    dataSource: MatTableDataSource<Cv, MatPaginator>;

    isInfoVisible = false; 

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private authService: AuthenticationService,
        private router: Router,
        private cvService: CvService
    ) {
        authService.loggedInUser$.subscribe(user => {
            if (user === null || (user["authorities"][0]["authority"] || null) !== "ROLE_COMPANY") {
                router.navigateByUrl("/").then();
            }
            else {
                cvService.getAllCvs().then(
                    (res: Cv[]) => {
                        cvService.CVs = res;
                        this.dataSource = new MatTableDataSource(cvService.CVs);
                        this.dataSource.paginator = this.paginator;
                        this.dataSource.sort = this.sort;
                    },
                    err => console.error(err)
                );
            }
        });
    }

    ngOnInit(): void { }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value
            .trim()
            .toLowerCase()
            .split(/[\s,]+/)
            .map(val => val.trim());
        this.dataSource.filterPredicate = (data: any, filter: string) => {
            return filterValue.every(keyword =>
                Object.values(data).some(value =>
                    typeof value === 'string' && value.toLowerCase().includes(keyword)
                )
            );
        };
        this.dataSource.filter = filterValue.join(',');
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    toggleInfo(show: boolean): void {
        this.isInfoVisible = show;  
    }

    downloadCV(cvId: number, cv: Cv) {
        this.cvService.getPDF(cvId).then(
            (res: Blob) => {

                // if (window.navigator && window.navigator.msSaveOrOpenBlob)
                //     window.navigator.msSaveOrOpenBlob(res);
                
                const data = window.URL.createObjectURL(res);
                const link = document.createElement('a');

                link.href = data;
                link.target = "_blank";
                link.download = (cv.firstName + '_' + cv.lastName + '_CV' + '.pdf').replace(/ /g, '');
                link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

                setTimeout(() => {
                    (window.URL || window.webkitURL).revokeObjectURL(data);
                    link.remove();
                }, 100);
            }).catch(console.error);
    }
}

